<template>
  <div class="water-outage-management-page">
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 20px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="事件名称">
                <a-input v-model="query.eventName" placeholder="请输入事件名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="事件编号">
                <a-input v-model="query.eventNo" placeholder="请输入事件编号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="关联编号">
                <a-input v-model="query.associationNo" placeholder="请输入关联编号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="状态">
                <a-select placeholder="请选择状态" v-model="query.status" allow-clear>
                  <a-select-option value="0"> 未处理 </a-select-option>
                  <a-select-option value="1"> 已处理 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()" v-action:add
                >新增</a-button
              >
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button
                type="primary"
                style="margin-left: 12px"
                @click="exportHandle()"
                :loading="exportLoading"
                v-action:export
                >导出</a-button
              >
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        ref="table"
        rowKey="id"
        :scroll="{ x: 1900 }"
        :columns="columns"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="list"
        :pagination="pagination"
        @change="pageChange"
        bordered
      >
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 0" color="rgb(255, 99, 71)">未处理</a-tag>
          <a-tag v-if="text === 1" color="rgb(50, 205, 50)">已处理</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="addOrUpdateHandle(record.id)" style="margin-right: 5px" v-if="record.status === 0" v-action:edit
            >编辑</a
          >
          <a @click="dealwith(record.id)" style="margin-right: 5px" v-if="record.status === 0" v-action:dealwith
            >处理</a
          >
          <a @click="Details(record.id)">详情</a>
        </span>
      </a-table>
      <!-- 详情 -->
      <Wateroutagedetails ref="Wateroutagedetails" />
      <!-- <a-modal
        title="详情"
        width="50%"
        v-model="DetailsVisible"
        @ok="DetailsVisible = false"
        @cancel="DetailsVisible = false"
      >
        <a-row class="Details-row" type="flex" justify="center" :gutter="4">
          <a-col :md="12" :sm="24"> 事件编号：{{ DetailsData.eventNo }}</a-col>
          <a-col :md="12" :sm="24"> </a-col>
          <a-col :md="12" :sm="24">事件名称：{{ DetailsData.eventName }} </a-col>
          <a-col :md="12" :sm="24">事件来源：{{ DetailsData.source }}</a-col>
          <a-col :md="12" :sm="24">
            管段信息： <a-button type="primary" @click="openMap(1)">点击查看管道</a-button></a-col
          >
          <a-col :md="12" :sm="24"> </a-col>
          <a-col :md="12" :sm="24"> 开始分类编号：{{ DetailsData.startClassNo }}</a-col>
          <a-col :md="12" :sm="24">结束分类编号：{{ DetailsData.endClassNo }} </a-col>
          <a-col :md="12" :sm="24"> 计划停水开始时间：{{ DetailsData.planStartTime }}</a-col>
          <a-col :md="12" :sm="24">计划停水结束时间：{{ DetailsData.planEntTime }} </a-col>
          <a-col :md="12" :sm="24"> 事件管理员：{{ DetailsData.adminName }}</a-col>
          <a-col :md="12" :sm="24">事件负责人：{{ DetailsData.principalName }} </a-col>
          <a-col :md="12" :sm="24"> 停水管理员：{{ DetailsData.waterAdminName }}</a-col>
          <a-col :md="12" :sm="24">
            事件状态： <span v-if="DetailsData.status === 0">未处理</span>
            <span v-if="DetailsData.status === 1">已处理</span></a-col
          >
          <a-col :md="24" :sm="24" style="margin-top: 15px">描述：{{ DetailsData.describe }} </a-col>
          <a-col :md="24" :sm="24" style="margin-top: 15px"
            >附件：
            <div class="fileDiv">
              <ul>
                <li class="fileLi" v-for="item in DetailsData.fileNames" :key="item.url">
                  <img :src="item.url" alt="" style="width: 80px; height: 75px" @click="pumpurlimg(item.url)" />
                </li>
              </ul>
            </div></a-col
          >
        </a-row>
      </a-modal> -->
      <!-- 图片 -->
      <a-modal
        title="图片"
        style="top: 20px"
        :width="800"
        :footer="null"
        :visible="visibles"
        :confirm-loading="confirmLoading"
        @cancel="handleCancelh"
      >
        <img :src="this.pumpUrlg" :alt="this.pumpUrlg" style="width: 100%; height: 100%" />
      </a-modal>
      <!-- 处理 -->
      <a-modal title="处理" width="50%" v-model="dealwithVisible" @ok="dealwithOk" @cancel="dealwithCancel">
        <a-form-model
          class="log-form"
          :model="gisWaterEve"
          ref="gisWaterEve"
          :rules="rulese"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-row class="form-row" type="flex" justify="center" :gutter="4">
            <a-col :md="24" :sm="24">
              <a-form-model-item label="处理人" prop="handleName" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-input v-model="gisWaterEve.handleName" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-modal>
      <a-modal class="log-form" :title="'选取位置'" width="50%" v-model="showMap" @ok="closeMap" @cancel="closeMap2">
        <input class="login-input" type="text" v-model="startLine" placeholder="请输入开始分类编码" />
        <input class="login-input" type="text" v-model="endLine" placeholder="请输入结束分类编码" />
        <a-button type="submit" @click="searchMapLine">查询</a-button>
        <mapTemplate ref="waterMap" @childByValue="childByValue"></mapTemplate>
      </a-modal>

      <a-modal :title="this.title" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form-model
          class="log-form"
          :model="gisWaterEvent"
          ref="gisWaterEvent"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-row class="form-row" type="flex" justify="center" :gutter="4">
            <a-col :md="24" :sm="24">
              <a-form-model-item label="事件编号" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <span v-if="!gisWaterEvent.eventNo">(系统自动生成)</span>
                <span v-else>{{ gisWaterEvent.eventNo }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-model-item label="事件名称" prop="eventName" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-input v-model="gisWaterEvent.eventName" placeholder="请输入事名称" />
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-model-item label="管段信息" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-button type="primary" @click="openMap(2)">点击选择管道</a-button>
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="开始分类编码" prop="startClassNo">
                <a-input v-model="gisWaterEvent.startClassNo" placeholder="请输入开始分类编码" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="结束分类编码" prop="endClassNo">
                <a-input v-model="gisWaterEvent.endClassNo" placeholder="请输入结束分类编码" disabled />
              </a-form-model-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-model-item
                label="计划停水开始时间"
                prop="startValue"
                :label-col="{ span: 8 }"
                :wrapper-col="{ span: 16 }"
              >
                <a-date-picker
                  v-model="gisWaterEvent.startValue"
                  :disabled-date="disabledStartDate"
                  style="width: 166px"
                  @change="onChanges"
                  format="YYYY-MM-DD HH:mm:ss"
                  @openChange="handleStartOpenChange"
                />
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item
                label="计划停水结束时间"
                prop="endValue"
                :label-col="{ span: 8 }"
                :wrapper-col="{ span: 16 }"
              >
                <a-date-picker
                  v-model="gisWaterEvent.endValue"
                  :disabled-date="disabledEndDate"
                  style="width: 166px"
                  format="YYYY-MM-DD HH:mm:ss"
                  :open="endOpen"
                  @change="onChanget"
                  @openChange="handleEndOpenChange"
                />
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="事件管理员" prop="adminId">
                <a-select
                  show-search
                  style="width: 200px"
                  v-model="gisWaterEvent.adminId"
                  placeholder="请选择事件管理员"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in userlist" :key="item.id" :value="item.id">{{
                    item.realName
                  }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="事件负责人" prop="principalId">
                <a-select
                  show-search
                  style="width: 200px"
                  v-model="gisWaterEvent.principalId"
                  placeholder="请选择事件负责人"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in userlist" :key="item.id" :value="item.id">{{
                    item.realName
                  }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-model-item label="停水管理员" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-input disabled v-model="gisWaterEvent.waterAdminName" placeholder="自动生成" />
              </a-form-model-item>
            </a-col>

            <!-- <a-col :md="24" :sm="24">
              <a-form-model-item
                label="模板选择"
                prop="templateId"
                :label-col="{ span: 3 }"
                :wrapper-col="{ span: 20 }"
              >
                <a-select
                  v-model="gisWaterEvent.templateId"
                  placeholder="请选择短信模板"
                  allow-clear
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="item in aliyunTemplateList" :key="item.id" :value="item.id">
                    {{ item.templateName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-model-item label="模板内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-input
                  :value="selectedTemplateContent"
                  type="textarea"
                  :rows="3"
                  disabled
                  placeholder="请先选择短信模板"
                />
              </a-form-model-item>
            </a-col> -->
            <a-col :md="24" :sm="24">
              <a-form-model-item label="事件描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="describe">
                <a-textarea placeholder="多行输入" v-model="gisWaterEvent.describe" :rows="2" />
              </a-form-model-item>
            </a-col>
            <a-col :md="24" :sm="24">
              <a-form-model-item label="附件上传" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-upload-dragger name="file" :multiple="true" :customRequest="customRequest" :showUploadList="false">
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                  </p>
                  <p class="ant-upload-text">
                    文件拖拽此处或
                    <a>点击上传</a>
                  </p>
                </a-upload-dragger>
                <div class="fileDiv">
                  <a-row style="margin-top: 20px">
                    <a-col :span="12">
                      <div class="fileDiv">
                        图片：
                        <ul>
                          <li class="fileLi" v-for="item in fileNamesimg" :key="item.url">
                            <img :src="item.url" alt="" style="width: 80px; height: 80px" @click="clicimg(item.url)" />
                          </li>
                        </ul>
                      </div>
                    </a-col>
                    <a-col :span="12">
                      <div class="fileDiv">
                        文件：
                        <ul>
                          <li class="fileLi" v-for="item in fileNamestex" :key="item.url">
                            <div class="uploadDiv" @click="uploadFile(item)">
                              <a-icon type="file-done" style="cursor: pointer" />
                              {{ item.name }}
                            </div>
                            <a-icon
                              type="delete"
                              style="float: right; cursor: pointer; margin-top: -28px; margin-right: 146px"
                              @click="deleteFile(item.url)"
                            />
                          </li>
                        </ul>
                      </div>
                    </a-col>
                  </a-row>
                  <!-- <ul>
                    <li class="fileLi" v-for="item in gisWaterEvent.fileNames" :key="item.url">
                      <div class="uploadDiv" @click="uploadFile(item)">
                        <a-icon type="file-done" style="cursor: pointer" />
                        {{ item.name }}
                      </div>
                      <a-icon type="delete" style="float: right; cursor: pointer" @click="deleteFile(item.url)" />
                    </li>
                  </ul> -->
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import mapTemplate from './map-template.vue'
import Wateroutagedetails from './components/Water-outage-details.vue'
import dayjs from 'dayjs'
import { getAliyunTemplates } from '@/api/aliyunSms'

export default {
  components: {
    dayjs,
    mapTemplate,
    Wateroutagedetails
  },
  mixins: [mixinViewModule],
  data() {
    return {
      startLine: '',
      endLine: '',
      showMap: false,
      currentId: '',
      dayjs,
      isUpdate: false,
      endOpen: false,
      dealwithVisible: false,
      title: '新增',
      equipmentList: [],
      parameterList: [],
      userlist: [],
      queryUrl: '/pipe-network/gis_water_events/page',
      addOrUpdateUrl: '/pipe-network/gis_water_events',
      deleteUrl: '/pipe-network/gis_water_events', // 删除数据url
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryOneUrl: '/pipe-network/gis_water_events/',
      uploadUrl: 'manager/file/resources/upload', // 上传文件URL
      exportDataUrl: 'pipe-network/gis_water_events/export', // 导出
      exportFileName: '停水管控事件.xlsx',
      visible: false,
      visibles: false,
      pumpUrlg: '',
      DetailsVisible: false,
      confirmLoading: false,
      list: [],
      zoneTreeData: [], // 分区数据选项
      query: {
        mainValve: '',
        planName: '',
        interworkingValve: '',
        isEnable: ''
      },
      gisWaterEve: {
        handleName: '',
        id: '',
        status: 1
      },
      fileNamesimg: [],
      fileNamestex: [],
      gisWaterEvent: {
        eventNo: '',
        eventName: '',
        startClassNo: '',
        endClassNo: '',
        endValue: '',
        startValue: '',
        describe: '',
        planEntTime: '',
        waterAdminName: '',
        eventAddress: '',
        planStartTime: '',
        fileNames: [],
        adminId: '',
        principalId: '',
        lineId: '',
        templateId: undefined
      },
      DetailsData: {},
      aliyunTemplateList: [],
      columns: [
        {
          title: '事件编号',
          dataIndex: 'eventNo'
        },
        {
          title: '事件名称',
          dataIndex: 'eventName'
        },
        {
          title: '开始分类编码',
          dataIndex: 'startClassNo',
          scopedSlots: { customRender: '' }
        },
        {
          title: '结束分类编码',
          dataIndex: 'endClassNo'
        },
        {
          title: '上报人/创建人',
          dataIndex: 'createName'
        },
        {
          title: '上报时间/创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '事件描述',
          dataIndex: 'describe'
        },
        {
          title: '处理状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '处理人',
          dataIndex: 'handleName'
        },
        {
          title: '处理时间',
          dataIndex: 'handleTime'
        },
        {
          title: '关联编号',
          dataIndex: 'associationNo'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  computed: {
    selectedTemplateContent() {
      if (!this.gisWaterEvent.templateId) return ''
      const t = this.aliyunTemplateList.find((item) => (item.templateCode || item.id) === this.gisWaterEvent.templateId)
      if (!t || !t.templateContent) return ''
      // 替换模板变量
      let content = t.templateContent
      const { eventNo, eventName, planStartTime, planEntTime } = this.gisWaterEvent
      if (eventNo) {
        content = content.replace(/\$\{event_no\}/g, eventNo)
      }
      if (eventName) {
        content = content.replace(/\$\{event_name\}/g, eventName)
      }
      if (planStartTime) {
        content = content.replace(/\$\{s_time\}/g, planStartTime)
      }
      if (planEntTime) {
        content = content.replace(/\$\{e_time\}/g, planEntTime)
      }
      return content
    },
    rules() {
      return {
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
        describe: [{ required: true, message: '请输入描述', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择计划开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择计划完成时间', trigger: 'change' }],
        principalId: [{ required: true, message: '请选择事件负责人', trigger: 'change' }],
        adminId: [{ required: true, message: '请选择事件管理员', trigger: 'change' }],
        startClassNo: [{ required: true, message: '请输入开始分类编码', trigger: 'change' }],
        endClassNo: [{ required: true, message: '请输入结束分类编码', trigger: 'change' }],
        templateId: [{ required: true, message: '请选择短信模板', trigger: 'change' }]
      }
    },
    rulese() {
      return {
        handleName: [{ required: true, message: '请输入处理人名称', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.resetList()
    this.queryList()
    this.currentUser()
  },
  methods: {
    // 缩略图
    clicimg(i) {
      this.pumpUrlg = i
      this.visibles = true
    },
    handleCancelh() {
      this.visibles = false
    },
    childByValue(childValue) {
      this.startLine = childValue[0].properties.start_class_no
      this.endLine = childValue[0].properties.end_class_no
      this.gisWaterEvent.lineId = childValue[0].id.substr(childValue[0].id.lastIndexOf('.') + 1, 20)
    },
    async loadAliyunTemplates() {
      try {
        const res = await getAliyunTemplates({ ispage: 1 })
        const rows = res?.rows || []
        this.aliyunTemplateList = rows.flatMap((r) => r.aliyunTemplateVos || [])
      } catch (e) {
        this.aliyunTemplateList = []
      }
    },
    changeStartAndEnd(start, end) {
      this.startLine = start
      this.endLine = end
    },
    openMap(i) {
      this.startLine = this.gisWaterEvent.startClassNo || ''
      this.endLine = this.gisWaterEvent.endClassNo || ''
      this.showMap = true
      if (this.startLine.length > 0 || this.endLine.length > 0) {
        this.$nextTick(() => {
          this.$refs.waterMap.searchLines(this.startLine, this.endLine)
        })
      }
    },
    closeMap() {
      this.showMap = false
      this.gisWaterEvent.startClassNo = this.startLine
      this.gisWaterEvent.endClassNo = this.endLine
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine() {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    currentUser() {
      this.gisWaterEvent.waterAdminName = this.$store.getters.userInfo.nickName
    },
    Details(id) {
      this.$refs.Wateroutagedetails.ReassignHandle(id)
    },
    dealwith(ids) {
      this.gisWaterEve.id = ids
      this.dealwithVisible = true
    },
    dealwithCancel() {
      this.dealwithVisible = false
      this.$refs.gisWaterEve.resetFields()
    },
    dealwithOk(e) {
      e.preventDefault()
      this.$refs.gisWaterEve.validate((valid) => {
        if (valid) {
          this.$http
            .put(this.addOrUpdateUrl, {
              id: this.gisWaterEve.id,
              ...this.gisWaterEve
            })
            .then((res) => {
              if (res.code === 0) {
                this.$refs.gisWaterEve.resetFields()
                this.dealwithVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    // 时间
    disabledStartDate(current) {
      // 11点02分
      return current && current < dayjs().startOf('day')
    },
    disabledEndDate(endValue) {
      const startValue = this.gisWaterEvent.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    onChanges(value, dateString) {
      this.gisWaterEvent.planStartTime = dateString
    },
    onChanget(value, dateString) {
      this.gisWaterEvent.planEntTime = dateString
    },
    handleChange(e) {},
    addOrUpdateHandle(id) {
      if (id == undefined) {
        this.title = '新增'
      } else {
        this.title = '编辑'
      }
      this.currentUser()
      this.getUserList()
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateVisible = true
      this.loadAliyunTemplates()
      if (id) {
        this.$nextTick(() => {
          this.$refs.gisWaterEvent.resetFields()
          if (id) {
            this.isUpdate = true
            this.$http
              .get(`${this.queryOneUrl}/${this.currentId}`)
              .then(({ data }) => {
                this.gisWaterEvent = {
                  eventNo: data.eventNo,
                  eventName: data.eventName,
                  startClassNo: data.startClassNo,
                  endClassNo: data.endClassNo,
                  endValue: data.planEntTime,
                  startValue: data.planStartTime,
                  planEntTime: data.planEntTime,
                  planStartTime: data.planStartTime,
                  describe: data.describe,
                  planEntTime: data.planEntTime,
                  waterAdminName: data.waterAdminName,
                  eventAddress: data.eventAddress || '',
                  adminId: data.adminId,
                  principalId: data.principalId,
                  fileNames: data.fileNames,
                  templateId: data.templateId,
                  lineId: data.lineId
                }
                if (this.gisWaterEvent.fileNames.length !== 0) {
                  for (var i = 0; i < this.gisWaterEvent.fileNames.length; i++) {
                    var index = this.gisWaterEvent.fileNames[i].url.lastIndexOf('.')
                    var ext = this.gisWaterEvent.fileNames[i].url.substr(index + 1)
                    function isAssetTypeAnImage(ext) {
                      return (
                        ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(
                          ext.toLowerCase()
                        ) !== -1
                      )
                    }
                    if (isAssetTypeAnImage(ext) == true) {
                      this.fileNamesimg.push(this.gisWaterEvent.fileNames[i])
                    } else {
                      this.fileNamestex.push(this.gisWaterEvent.fileNames[i])
                    }
                  }
                }
              })
              .catch(() => {})
          }
        })
      }
    },
    handleOk(e) {
      e.preventDefault()
      this.$refs.gisWaterEvent.validate((valid) => {
        if (valid) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, {
            id: this.currentId,
            ...this.gisWaterEvent
          })
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                this.gisWaterEvent.waterAdminName = ''
                this.gisWaterEvent.eventAddress = ''
                this.gisWaterEvent.eventNo = ''
                this.gisWaterEvent.fileNames = []
                this.gisWaterEvent.endClassNo = ''
                this.gisWaterEvent.startClassNo = ''
                this.gisWaterEvent.templateId = undefined
                this.fileNamestex = []
                this.fileNamesimg = []
                this.$refs.gisWaterEvent.resetFields()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    // 取消
    handleCancel(e) {
      console.log('Clicked cancel button')
      this.$refs.gisWaterEvent.resetFields()
      this.gisWaterEvent.waterAdminName = ''
      this.gisWaterEvent.eventAddress = ''
      this.gisWaterEvent.eventNo = ''
      this.gisWaterEvent.endClassNo = ''
      this.gisWaterEvent.startClassNo = ''
      this.gisWaterEvent.fileNames = []
      this.gisWaterEvent.templateId = undefined
      this.fileNamestex = []
      this.fileNamesimg = []
      this.visible = false
    },
    customRequest(data) {
      // 上传提交
      const formData = new FormData()
      formData.append('file', data.file)
      this.saveFile(formData)
    },
    saveFile(formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {},
        params: {},
        data: formData
      })
        .then((response) => {
          if (response.code === 0) {
            const obj = {
              url: response.data.url,
              name: response.data.fileName
            }
            if (this.gisWaterEvent.fileNames.length == 5) {
              this.$message.error('最多上传5个文件')
            } else {
              this.gisWaterEvent.fileNames.push(obj)
              var index = obj.url.lastIndexOf('.')
              var ext = obj.url.substr(index + 1)
              function isAssetTypeAnImage(ext) {
                return (
                  ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
                )
              }
              if (isAssetTypeAnImage(ext) == true) {
                this.fileNamesimg.push(obj)
                console.log(this.fileNamesimg, 'gggg')
              } else {
                this.fileNamestex.push(obj)
                console.log(this.fileNamestex, 'gggg')
              }
            }
            // this.gisWaterEvent.fileNames.push(obj)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    uploadFile(item) {
      const link = document.createElement('a') // 创建a标签
      link.download = item.name // a标签添加属性
      link.style.display = 'none'
      link.href = item.url
      document.body.appendChild(link)
      link.click() // 执行下载
      document.body.removeChild(link) // 释放标签
    },
    deleteFile(url) {
      const index = this.gisWaterEvent.fileNames.findIndex((item) => {
        return item.url == url
      })
      console.log(index)
      this.gisWaterEvent.fileNames.splice(index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
/* 避免卡片 overflow:hidden 与固定列表格在布局里把整页“锁死”无法纵向滚动 */
.water-outage-management-page {
  width: 100%;
  min-height: 0;
  padding-bottom: 24px;
}

/deep/ .ant-card {
  overflow: visible;
}

/deep/ .ant-card-body {
  overflow: visible;
}

/* 宽表 + 固定列：仅横向滚动交给表格内部，不占用纵向滚动条 */
/deep/ .ant-table-scroll {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

/deep/ .ant-table-body {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

/deep/.table-striped {
  background-color: #fafafa;
}
/deep/ .ant-table-thead > tr > th {
  text-align: center;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
}
/deep/.Details-row > .ant-col-md-12 {
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  margin-top: 20px;
}
</style>
